<div class="schedule-navbar">
    <mat-form-field class="picker-date">
        <input
            [matDatepicker]="pickerDate"
            [max]="maxDateValue"
            [formControl]="fcDate"
            (focus)="pickerDate.open()"
            matInput
            tabindex="-1" />
        <mat-datepicker #pickerDate></mat-datepicker>
    </mat-form-field>
    <div>
        <button (click)="prev()" mat-icon-button color="white">
            <mat-icon fontSet="far" fontIcon="fa-chevron-left"></mat-icon>
        </button>
    </div>
    <div class="content" (click)="pickerDate.open()">
        <p class="large">{{ date | date: 'd MMM' }}</p>
        <p class="small">{{ date | date: 'EEEE' }}</p>
    </div>
    <div>
        <button [disabled]="disableNext" (click)="next()" mat-icon-button color="white">
            <mat-icon fontSet="far" fontIcon="fa-chevron-right"></mat-icon>
        </button>
    </div>
</div>
@if (openPreviousDays?.length) {
    <div class="open-days">
        <div class="name">Goed te keuren uren:<br /></div>
        @for (open of openPreviousDays; track open.bookdate; let last = $last) {
            <div class="open" routerLink="/check-hours/{{ open.bookdate | date: 'yyyy-MM-dd' }}">
                <span class="date">{{ open.bookdate | date: 'EEE d MMM' }}</span>
                <span class="count">{{ open.count }}</span>
            </div>
        }
    </div>
}
<div class="check-hours-check first">
    <div class="header">
        <div class="container-xl">
            <div class="content row">
                <div class="col d-flex justify-content-center">
                    <mat-checkbox [formControl]="fcHideApproved"> Verberg goedgekeurd </mat-checkbox>
                </div>
                <div class="col d-flex justify-content-center">
                    @if (userFunctions) {
                        <mat-form-field appearance="outline">
                            <mat-label>Filter op functie</mat-label>
                            <mat-select [formControl]="fcUserFunction" multiple>
                                @for (userFunction of userFunctions; track userFunction) {
                                    <mat-option [value]="userFunction">
                                        {{ userFunction }}
                                    </mat-option>
                                }
                            </mat-select>
                        </mat-form-field>
                    }
                </div>
                @if (Functionalities.CommonHourCheck | hasFunctionality) {
                    <div class="col d-flex justify-content-center">
                        <mat-form-field appearance="outline">
                            <mat-label>Filter op uursoort</mat-label>
                            <mat-select [formControl]="fcHourType" multiple>
                                <mat-option [value]="RealisationHourtype.worktime"> Werktijd </mat-option>
                                <mat-option [value]="RealisationHourtype.illness"> Ziek </mat-option>
                                <mat-option
                                    value="{{ RealisationHourtype.driving_to }}|{{ RealisationHourtype.driving_back }}">
                                    Transporttijd
                                </mat-option>
                                <mat-option
                                    value="{{ RealisationHourtype.travel_to }}|{{ RealisationHourtype.travel_back }}">
                                    Reistijd
                                </mat-option>
                                <mat-option [value]="RealisationHourtype.frost"> Spaaruren </mat-option>
                                <mat-option [value]="RealisationHourtype.day_off"> Roostervrij </mat-option>
                                <mat-option [value]="RealisationHourtype.sleep"> Slapen </mat-option>
                                <mat-option [value]="RealisationHourtype.education"> Scholing </mat-option>
                                <mat-option [value]="RealisationHourtype.bank_holiday"> Feestdag </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                }
                @if (Features.DynamicPerformer | hasFeature) {
                    <div class="col d-flex justify-content-center">
                        <mat-form-field appearance="outline">
                            <mat-label>Filter op {{ environment.executorName }}</mat-label>
                            <mat-select [formControl]="fcExecutor">
                                <mat-option [value]="null"> Alle {{ environment.executorNamePlural }} </mat-option>
                                @if (LocalStorage.user.checks_hours) {
                                    <mat-option value="checkFor"> Goed te keuren personen </mat-option>
                                }
                                @for (executor of executors; track executor) {
                                    <mat-option [value]="executor.id">
                                        {{ executor.name }}
                                    </mat-option>
                                }
                            </mat-select>
                        </mat-form-field>
                    </div>
                }
            </div>
            <div class="content justify-content-center">
                <small>
                    Er {{ filteredEmployees === 1 ? 'wordt' : 'worden' }} {{ filteredEmployees }} van
                    {{ totalEmployees }} medewerker{{ totalEmployees === 1 ? '' : 's' }} getoond
                </small>
            </div>
        </div>
    </div>
</div>

<app-hour-control
    [(selectedRealisations)]="selectedRealisations"
    [realisations]="filteredRealisations"
    [groupingType]="'project_category'"
    [allowEdit]="allowEdit"
    [loadingData]="loadingData"
    [highlight]="highlight ?? null"
    [executors]="executors"
    [showContextPerformer]="fcExecutor.value === null"
    (copyPreviousDayRequested)="$event.key === 'staff' ? getStaffFromPrevDay($event) : getFromPrevDay($event)"
    (projectCommentRequested)="editProjectComment($event)"
    (projectEditRequested)="editProject($event)"
    (projectsEditRequested)="editProjects($event)"
    (projectOpenRequested)="openProjectEditDialog($event)">
</app-hour-control>

<div class="button-wrapper">
    <div class="container-xl">
        <div class="buttons">
            @if (selectedRealisations?.length && Features.RealisationScheduleMovePerformerSave | hasFeature) {
                <button class="planning-button" (click)="clearSelection()" mat-raised-button color="accent">
                    Selectie wissen ({{ selectionCount }})
                </button>
            } @else if (!(Functionalities.PeriodSettlementExecution | hasFunctionality)) {
                <button class="planning-button" mat-raised-button color="accent" routerLink="/weekschedule">
                    Weekoverzicht
                </button>
            } @else {
                <button
                    class="planning-button"
                    mat-raised-button
                    color="accent"
                    routerLink="/dagcontrole/{{ date | date: 'yyyy-MM-dd' }}">
                    Dagcontrole
                </button>
            }
            <div class="settings-menu">
                <app-settings-menu [date]="date"></app-settings-menu>
            </div>
            @if (!(null | notEditable: date)) {
                @if (selectedRealisations?.length && Features.RealisationScheduleMovePerformerSave | hasFeature) {
                    <button
                        class="planning-button"
                        (click)="moveSelectionToPerformer()"
                        mat-raised-button
                        color="primary">
                        Verplaatsen naar uitvoerder ({{ selectionCount }})
                    </button>
                } @else {
                    <button class="planning-button" (click)="add()" mat-raised-button color="primary">Toevoegen</button>
                }
            }
        </div>
    </div>
</div>
